<template>
  <v-container class="recursos-pagina">
    <v-btn text :to="{ name: 'city.list' }">Voltar às instituições</v-btn>
    <h1>{{ municipioId ? 'Recursos da instituição' : 'Recursos do Estado' }}</h1>
    <p v-if="nomeInstituicao">{{ nomeInstituicao }}</p>
    <v-progress-linear v-if="carregando" indeterminate />
    <v-alert v-if="erro" type="info" outlined>{{ erro }}</v-alert>
    <p v-if="estado && !etapaRecursal">Os recursos serão liberados após a divulgação do resultado, conforme a etapa e o prazo da instituição.</p>
    <recursos-ciclo v-if="estado && etapaRecursal" :uf="uf" :ano="2026" :estado="estado" :municipio-id="municipioId" :municipios="instituicoes" :bloqueado="carregando" @registrado="carregar" />
  </v-container>
</template>
<script>
import { seloFechamentoAPI } from '../API/SeloFechamentoAPI';
import { normalizarDados, mensagemErro } from '../utils';
import RecursosCiclo from './RecursosCiclo.vue';
import { atualUfDefinition } from '@/helpers/utils';
import { mapGetters } from 'vuex';
export default {
  name: 'SeloRecursosPagina', components: { RecursosCiclo }, props: { municipioId: [String, Number] },
  data() { return { carregando: false, estado: null, municipios: [], erro: '', config: JSON.parse(localStorage.getItem('config') || '{}'), groupsConfig: JSON.parse(localStorage.getItem('groupsConfig') || '{}') }; },
  computed: {
    ...mapGetters(['isFullAdmin']),
    podeAcessar() { const flag=this.municipioId?'recursos':'painelRecursosEstado'; return this.isFullAdmin || !!(this.config && this.groupsConfig && this.config[flag] && this.groupsConfig[flag]); },
    uf() { return String(atualUfDefinition.uf || this.$store.state.uf || '').toUpperCase(); },
    instituicoes() { const liberadas=this.municipios.filter(m => m.podeVerResultado); return this.municipioId ? liberadas.filter(m => m.municipioId === Number(this.municipioId)) : liberadas; },
    nomeInstituicao() { return this.municipioId && this.instituicoes.length ? this.instituicoes[0].nome : ''; },
    etapaRecursal() { return this.estado && this.estado.etapa >= 5; },
  },
  mounted() { this.carregar(); },
  watch: { municipioId() { this.carregar(); } },
  methods: {
    async carregar() {
      this.carregando = true; this.erro = ''; this.estado=null; this.municipios=[];
      try {
        if(!this.podeAcessar) {this.erro='Acesso a recursos não liberado nas permissões do sistema e do grupo.';return;}
        const permissions=await seloFechamentoAPI.permissoesRecursos(this.uf,2026);
        if(!(this.municipioId?permissions.data.podeVerMunicipio:permissions.data.podeVerPainel)) {this.erro='Acesso a recursos não liberado nas permissões do sistema e do grupo.';return;}
        if(this.municipioId) {
          const {data}=await seloFechamentoAPI.visibilidadeMunicipio(this.uf,2026,this.municipioId);
          if(!data.podeAcessarRecursos) { this.estado=null; this.municipios=[]; this.erro=data.resultadoReservado ? 'Recursos desta instituição disponíveis após a divulgação Nacional.' : 'Acesso a recursos não liberado nas permissões do sistema e do grupo.'; return; }
        }
        const [estado, municipios] = await Promise.all([seloFechamentoAPI.estado(this.uf,2026),seloFechamentoAPI.municipios(this.uf,2026)]); this.estado=normalizarDados(estado.data); this.municipios=normalizarDados(municipios.data);
      }
      catch(error) { this.estado=null; this.erro=mensagemErro(error); }
      finally { this.carregando=false; }
    },
  },
};
</script>
<style scoped>.recursos-pagina { max-width: 1200px; padding: 28px; }h1 { font-size: 26px; margin-bottom: 12px; }</style>
